import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const WalletPage = React.lazy(() => import("./WalletPage"));
const WalletContacts = React.lazy(() => import("./WalletContacts"));

const walletModuleConfig: ModuleConfig = {
  id: "wallet",
  name: "Wallet",
  description:
    "Your signing key and address book — prove things are yours without a password, and never paste a raw address twice",
  version: "0.1.0",
  enabled: true,
  category: "business",
  order: 14,
  icon: "🔑",
  // eslint-disable-next-line no-restricted-syntax -- module tile accent; matches the other moduleConfigs, which all carry a literal here
  color: "#7C3AED",

  routes: [
    // Literal segments precede any param so the param cannot swallow them.
    { path: "/wallet/contacts", component: WalletContacts, permissionLevel: "view", useLayout: true, layoutOptions: { maxW: "container.lg", py: 6 } },
    { path: "/wallet", component: WalletPage, permissionLevel: "view", useLayout: true, layoutOptions: { maxW: "container.lg", py: 6 } },
  ],

  navigation: [
    { label: "My wallet", path: "/wallet", icon: "🔑", permissionLevel: "view" },
    { label: "Address book", path: "/wallet/contacts", icon: "📇", permissionLevel: "view" },
  ],

  // Resolved from the backend SSOT at runtime — ships EMPTY on purpose.
  permissions: { view: [], create: [], edit: [], delete: [] },

  quickActions: [
    { label: "My wallet", path: "/wallet", icon: "🔑", description: "Your signing key and address book" },
  ],

  changelog: [
    {
      version: "0.1.0",
      releaseDate: "2026-09-05",
      title: "Initial release — a key that proves who you are, and never loses its history",
      features: [
        "✅ Keys kept as a HISTORY, so a signature from March still verifies in December after two rotations",
        "✅ RETIRED and REVOKED are different facts: a replaced key's signatures stand, a stolen key's do not",
        "✅ Rotation proves continuity of PERSON — the new key signs, the old key countersigns",
        "✅ EIP-712, the standard Snapshot and every hardware wallet already speak",
        "✅ A browser key unlocked by an emailed code — nothing to remember, nothing to lose",
        "⚠️ That browser key is SEMI-custodial by design, and every screen says so",
        "✅ Hardware wallet linking through MetaMask, for anything that holds value",
        "✅ A private address book — never paste a raw 0x twice",
        "✅ Contacts show whether an address was ever VERIFIED, rather than implying certainty",
        "✅ Two data exporters; keystores and codes never travel in them",
      ],
    },
  ],
};

export default walletModuleConfig;
